import { Search, Lightbulb, Rocket, Users, BarChart3 } from "lucide-react";

const STEPS = [
  { num: "01", icon: Search, title: "Research", desc: "Deep market & competitor analysis. Buyer persona mapping for your project.", testid: "process-research" },
  { num: "02", icon: Lightbulb, title: "Strategy", desc: "Channel mix, budgeting, creative direction, and KPI definition tailored to your goals.", testid: "process-strategy" },
  { num: "03", icon: Rocket, title: "Campaign Setup", desc: "Pixel tracking, ad accounts, audiences, creatives, and landing pages — all production-ready.", testid: "process-setup" },
  { num: "04", icon: Users, title: "Lead Generation", desc: "Always-on lead capture with real-time qualification and CRM sync to your sales team.", testid: "process-leadgen" },
  { num: "05", icon: BarChart3, title: "Conversion Optimization", desc: "Continuous A/B testing, creative refresh, and funnel tuning to lower CPL and lift conversions.", testid: "process-optimization" },
];

export const Process = () => {
  return (
    <section data-testid="process-section" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange mb-3">
            Our Process
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight tracking-tight">
            From research to revenue — in five disciplined steps
          </h2>
        </div>

        {/* Desktop horizontal timeline */}
        <div className="hidden lg:block relative">
          <div className="absolute top-9 left-0 right-0 h-[2px] bg-slate-200" />
          <div className="absolute top-9 left-0 h-[2px] bg-gradient-to-r from-orange to-blue w-full" />
          <div className="grid grid-cols-5 gap-6 relative">
            {STEPS.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.testid} data-testid={s.testid} className="text-left">
                  <div className="relative w-[72px] h-[72px] rounded-2xl bg-white border-2 border-orange flex items-center justify-center mb-5 shadow-lg shadow-orange/10">
                    <Icon size={28} className="text-orange" />
                    <span className="absolute -top-2 -right-2 bg-navy text-white text-[10px] font-bold w-7 h-7 rounded-full flex items-center justify-center">{s.num}</span>
                  </div>
                  <h3 className="font-bold text-navy text-lg mb-2">{s.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mobile vertical timeline */}
        <div className="lg:hidden relative pl-12">
          <div className="absolute left-[28px] top-3 bottom-3 w-[2px] bg-gradient-to-b from-orange via-orange to-blue" />
          <div className="space-y-8">
            {STEPS.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.testid} data-testid={s.testid} className="relative">
                  <div className="absolute -left-12 top-0 w-14 h-14 rounded-2xl bg-white border-2 border-orange flex items-center justify-center shadow-lg shadow-orange/10">
                    <Icon size={22} className="text-orange" />
                  </div>
                  <div className="pl-2">
                    <span className="text-xs font-bold text-orange tracking-wider">STEP {s.num}</span>
                    <h3 className="font-bold text-navy text-lg mt-1 mb-1.5">{s.title}</h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
